import styled from "@emotion/styled";
import actions from "src/actions/Exam";

import DefaultOptionsList from "./DefaultOptionsList";

function Options({ question, details, state, dispatch }) {
	const { settings, additionalSettings } = state;

	return (
		<div className="question--options">
			<DefaultOptionsList
				settings={settings}
				details={details}
				question={question}
				additionalSettings={additionalSettings}
				actions={actions}
				dispatch={dispatch}
			/>
		</div>
	);
}

export default styled(Options)``;
